import packageJson from "../../../package.json";

const VERSION_PLACEHOLDER = "__APP_VERSION__";

function readCloudRunAppVersion(): string | undefined {
	if (typeof document === "undefined") {
		return undefined;
	}
	const fromMeta = document.querySelector('meta[name="app-version"]')?.getAttribute("content")?.trim();
	if (!fromMeta || fromMeta === VERSION_PLACEHOLDER) {
		return undefined;
	}
	return fromMeta;
}

/** Cloud Run `APP_VERSION` (injected into index.html at container start). Local fallback is package.json. */
export const APP_VERSION: string = readCloudRunAppVersion() ?? packageJson.version;

/** Version from the currently loaded document meta tag. */
export function getCurrentAppVersion(): string | undefined {
	return readCloudRunAppVersion();
}

/** Fetch the live app version from network index.html (bypasses SW-served shell). */
export async function fetchLatestAppVersionFromNetwork(): Promise<string | undefined> {
	if (typeof fetch === "undefined") {
		return undefined;
	}
	try {
		const response = await fetch("/index.html?ngsw-bypass=true", {
			cache: "no-store",
			headers: { "ngsw-bypass": "true" },
		});
		if (!response.ok) {
			return undefined;
		}
		const html = await response.text();
		const match = html.match(/meta name="app-version" content="([^"]+)"/i);
		const version = match?.[1]?.trim();
		if (!version || version === VERSION_PLACEHOLDER) {
			return undefined;
		}
		return version;
	} catch {
		return undefined;
	}
}

export function formatAppVersion(version: string = APP_VERSION): string {
	if (!version) {
		return "";
	}
	return /^v/i.test(version) ? version : `v${version}`;
}
